import { ISOWellIngredientDTO } from 'business/models/CustomModels';
import { ConditionIngredientDTO, LayerTypeDTO } from 'business/models/Models';

export class ISOIngrdientInfo {
  public LayerType: LayerTypeDTO;
  //ingredient of user plate round(n)
  public sourceIngredientRow: ISOWellIngredientDTO;

  //ingredient of previous of current user plate round(n-1)
  public previousIngredientRow: ISOWellIngredientDTO;

  //score of user plate round(n)
  private _sourceScoreValue: number;
  public set sourceScoreValue(value: number) {
    this._sourceScoreValue = value;
  }
  public get sourceScoreValue() {
    if (ISOIngrdientInfo.customScoreDictionary != null) {
      return ISOIngrdientInfo.customScoreDictionary[this.sourceScoreKey];
    }

    return this._sourceScoreValue;
  }

  //score of user plate round(n-1)
  private _previousScoreValue: number;

  public set previousScoreValue(value: number) {
    this._previousScoreValue = value;
  }
  public get previousScoreValue(): number {
    if (ISOIngrdientInfo.customScoreDictionary != null) {
      return ISOIngrdientInfo.customScoreDictionary[this.previousScoreKey];
    }

    return this._previousScoreValue;
  }

  public sourceScoreKey: string;
  public previousScoreKey: string;

  public targetIngredientRow: ConditionIngredientDTO;

  public static customScoreDictionary: ScoreDictionary;
}

type ScoreDictionary = Record<string, number>;
